import { store } from "../app"

export const isLoggedIn = () => {
    const state = store.getState()
    return state.currentAccount.id ? true : false
}